import { dialogSecondaryActionStore } from "@app/stores/util.store.ts";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, ButtonGroup, Menu, MenuItem } from "@mui/material";
import { useStore } from "@tanstack/react-store";
import { Loader } from "bi-lib";
import { RefObject, useState } from "react";

interface Props {
    onSave: () => void | Promise<void>;
    onSecondary: () => void | Promise<void>;
    primaryActionTitle?: undefined | "Close";
    secondaryActionTitle: "Close" | "Add New";
    formRef?: RefObject<HTMLFormElement | null>;
    disabled?: boolean;
}

export default function SaveAndCloseOrAddButton({
    onSave,
    onSecondary,
    primaryActionTitle,
    secondaryActionTitle,
    formRef,
    disabled = false,
}: Props) {
    const [anchor, setAnchor] = useState<HTMLElement>();
    const [processing, setProcessing] = useState<1 | 2>();

    const dialogSecondaryAction = useStore(dialogSecondaryActionStore);

    const handleSave = async () => {
        if (formRef?.current?.reportValidity() == false) {
            return;
        }
        setProcessing(1);
        try {
            await onSave();
            if (dialogSecondaryAction == "action") {
                await onSecondary();
            }
        } finally {
            setProcessing(undefined);
        }
    };

    const handleAltSave = async () => {
        if (formRef?.current?.reportValidity() == false) {
            return;
        }
        setProcessing(2);
        try {
            await onSave();
            if (dialogSecondaryAction == "basic") {
                dialogSecondaryActionStore.setState(() => "action");
                await onSecondary();
            } else {
                dialogSecondaryActionStore.setState(() => "basic");
            }
        } finally {
            setAnchor(undefined);
            setProcessing(undefined);
        }
    };

    return (
        <>
            <ButtonGroup variant={"contained"}>
                <Button onClick={handleSave} type={"submit"} disabled={disabled || processing != undefined}>
                    Save{" "}
                    {dialogSecondaryAction == "action"
                        ? ` and ${secondaryActionTitle}`
                        : primaryActionTitle == undefined
                          ? null
                          : ` and ${primaryActionTitle}`}
                    {processing == 1 && <Loader size={18} padding={"0 0 0 10px"} />}
                </Button>
                <Button size="small" onClick={(e) => setAnchor(e.currentTarget)}>
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Menu
                open={!!anchor}
                anchorEl={anchor}
                onClose={() => setAnchor(undefined)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                MenuListProps={{ sx: { padding: 0 } }}
            >
                <MenuItem sx={{ padding: 0 }}>
                    <Button
                        type={"submit"}
                        sx={{ p: "10px 25px" }}
                        onClick={handleAltSave}
                        disabled={disabled || processing != undefined}
                    >
                        Save{" "}
                        {dialogSecondaryAction == "basic"
                            ? ` and ${secondaryActionTitle}`
                            : primaryActionTitle == undefined
                              ? null
                              : ` and ${primaryActionTitle}`}
                        {processing == 2 && <Loader size={18} padding={"0 0 0 10px"} />}
                    </Button>
                </MenuItem>
            </Menu>
        </>
    );
}
